import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReviewEntityResponse } from '../interfaces/review.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReviewStateService {
  private reviewEntitiesSubject = new BehaviorSubject<ReviewEntityResponse[]>([]);
  public reviewEntities$: Observable<ReviewEntityResponse[]> = this.reviewEntitiesSubject.asObservable();

  setReviewEntities(data: ReviewEntityResponse[]): void {
    if (!data || !Array.isArray(data)) {
      this.reviewEntitiesSubject.next([]);
      return;
    }
    this.reviewEntitiesSubject.next(data);
  }

  /** Get review entity by entity name (e.g. "LegalEntityProfile") */
  getReviewEntity(entityName: string): ReviewEntityResponse | undefined {
    const entities = this.reviewEntitiesSubject.value;
    const normalizedSearch = (entityName ?? '').trim().toLowerCase();
    return entities.find(e => {
      const normalizedEntity = (e.entityName ?? '').trim().toLowerCase();
      return normalizedEntity === normalizedSearch;
    });
  }

  /** Get all review entities */
  getAllReviewEntities(): ReviewEntityResponse[] {
    return this.reviewEntitiesSubject.value;
  }

  /** Check if a field is reviewed for a specific entity */
  isFieldReviewed(entityName: string, fieldName: string): boolean {
    const entity = this.getReviewEntity(entityName);
    if (!entity || !entity.fieldReviews) {
      return false;
    }
    return entity.fieldReviews.some(fr => fr.fieldName === fieldName);
  }

  /** Get reviewed field names for a specific entity */
  getReviewedFieldNames(entityName: string): string[] {
    const entity = this.getReviewEntity(entityName);
    if (!entity || !entity.fieldReviews) {
      return [];
    }
    return entity.fieldReviews.map(fr => fr.fieldName);
  }

  clear(): void {
    this.reviewEntitiesSubject.next([]);
  }
}
